import React, { Component } from "react";
import {
  reduxForm,
  destroy,
  arrayPush,
  arrayRemove,
  change,
  initialize,
} from "redux-form";
import { push, replace } from "react-router-redux";
import Input from "../../../../components/form/Input";
import DateField from "../../../../components/form/DateTime";
import Button from "../../../../components/form/Button";
import Select from "../../../../components/form/Select";
import Checkbox from "../../../../components/form/Checkbox";
import CroMunicipality from "../../components/generalForm/CroMunicipality";
import CroCountry from "../../components/generalForm/CroCountry";
import CroField from "../../components/generalForm/CroField";
import MultiSelect from "../../../../components/form/MultiSelect";
import CroSubhead from "../../components/generalForm/CroSubhead";
import InfoMessage from "../../components/InfoMessage";
import CroLabeledCmp from "../../components/generalForm/CroLabeledCmp";
import { styles } from "../../index";
import { isLogged, isInternal } from "../../CroUtils";
import { OfficialsInInitiative as OfficialGrid } from "../../components/grids/OfficialGrid";
import FilesGrid from "../../components/grids/FilesGrid";
import { dataInit } from "../../../../components/Grid/localActions";
import { Order } from "../../../../components/Grid/localProvider";
import fetch from "../../../../utils/fetch";
import { isNil, identity } from "lodash";
import {
  InitiativeState,
  InitiativeStateRaw,
  InitiativeResult,
} from "../../enum";
import * as V from "../../../../utils/formValidation";
import H from "../../helpEnum";
import { setLoading } from "../../../../actions/appActions";
import { getCzechRepublic } from "../../CroActions";
import CroTextAreaPrint from "../../components/generalForm/CroTextAreaPrint";

const FILES_GRID_NAME = "filesLocalGrid";
const RESULT_FILES_GRID_NAME = "resultFilesLocalGrid";

const FORM_NAME = "initiativeForm";
class InitiativeForm extends Component {
  state = {
    showLegalPerson: false,
  };

  componentWillMount() {
    const { dispatch, change, breadcrumbs, breadcrumbsItems, isNew } =
      this.props;
    breadcrumbs(breadcrumbsItems);
    if (isNew) {
      // set default country Czech republic
      getCzechRepublic(dispatch).then((result) => {
        change("person.deliveryAddress.country", result);
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.legalPerson !== this.props.legalPerson &&
      this.props.legalPerson
    )
      this.setState({ showLegalPerson: true });
  }

  changeLegalpersonSubform = () => {
    const { change, dispatch } = this.props;

    const newState = !this.state.showLegalPerson;
    this.setState({ showLegalPerson: newState });
    newState
      ? getCzechRepublic(dispatch).then((result) => {
          change("legalPerson.address.country", result);
        })
      : change("legalPerson", null);
  };

  render() {
    const {
      error,
      onSubmit,
      handleSubmit,
      accept,
      reject,
      send,
      submitting,
      disabled,
      onOfficialChange,
      onFileAdded,
      onRemoveFile,
      goBack,
      state,
      dispatch,
    } = this.props;
    const { auth, resultAttachments, attachments, rejectText, text } =
      this.props;

    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="cro-form initiativeForm"
      >
        <InfoMessage>
          Podnět směřující na neúplnost, nesprávnost či nepravdivost oznámení
          veřejného funkcionáře.
        </InfoMessage>
        {this.state.showLegalPerson && (
          <div className="initiativeForm__section">
            <CroSubhead title="Právnická osoba" />

            <div className="initiativeForm__grid initiativeForm__grid--legalPerson">
              <CroField
                className="half"
                title="Název"
                name="legalPerson.name"
                component={Input}
                disabled={disabled}
              />
              <CroField
                className="half"
                title="IČO"
                name="legalPerson.identificationNumber"
                component={Input}
                disabled={disabled}
                validate={[V.isNumeric]}
              />
            </div>

            <CroSubhead title="Sídlo" />

            <div className="initiativeForm__grid initiativeForm__grid--legalPerson">
              <CroCountry
                className="half"
                title="Stát"
                name="legalPerson.address"
                disabled={disabled}
                form={FORM_NAME}
              />
              <CroMunicipality
                className="half"
                title="Obec"
                name="legalPerson.address"
                disabled={disabled}
                form={FORM_NAME}
              />

              <CroField
                className="half"
                title="Ulice"
                name="legalPerson.address.street"
                component={Input}
                disabled={disabled}
              />

              <CroField
                className="half"
                title="Č.p./Č.o."
                name="legalPerson.address.orientationNumber"
                component={Input}
                disabled={disabled}
                helpEnum={H.HOUSE_NUMBER.r}
              />
              <CroField
                className="half"
                title="PSČ"
                name="legalPerson.address.zip"
                component={Input}
                disabled={disabled}
              />
            </div>
          </div>
        )}

        <div className="initiativeForm__section">
          <CroSubhead title="Kdo podnět podává" />

          <div className="initiativeForm__grid initiativeForm__grid--reporter">
            <label className="full">
              <span className="title">Je právnická osoba</span>
              <Checkbox
                value={this.state.showLegalPerson}
                onChange={this.changeLegalpersonSubform}
                disabled={disabled}
                aria-label="Je právnická osoba"
              />
            </label>

            <CroField
              className="half"
              title="Jméno"
              name="person.firstName"
              component={Input}
              disabled={disabled}
              validate={[V.textSpaceDashOnly, V.noSpaceStartEnd]}
            />
            <CroField
              className="half"
              title="Příjmení"
              name="person.lastName"
              component={Input}
              disabled={disabled}
              validate={[V.textSpaceDashOnly, V.noSpaceStartEnd]}
            />
            <CroField
              className="half"
              title="Další jména"
              name="person.middleName"
              component={Input}
              disabled={disabled}
            />
          </div>
        </div>

        <div className="initiativeForm__section">
          <CroSubhead
            title="Adresa pro doručování"
            helpEnum={H.INITIATIVE_ADRESS.r}
            tooltipPosition="top-right"
          />

          <div className="initiativeForm__grid initiativeForm__grid--delivery">
            <CroField
              className="half"
              title="Datová schránka"
              name="person.databox"
              component={Input}
              disabled={disabled}
            />
            <CroField
              className="half compact-input"
              title="E-mail"
              name="person.email"
              component={Input}
              disabled={disabled}
              validate={[V.email]}
              hintText="@"
            />

            <CroCountry
              className="half"
              title="Stát"
              name="person.deliveryAddress"
              disabled={disabled}
              form={FORM_NAME}
            />
            <CroMunicipality
              className="half compact-input"
              title="Obec"
              name="person.deliveryAddress"
              disabled={disabled}
              form={FORM_NAME}
            />

            <CroField
              className="half"
              title="Ulice"
              name="person.deliveryAddress.street"
              component={Input}
              disabled={disabled}
            />
            <CroField
              className="half"
              title="Č.p./Č.o."
              name="person.deliveryAddress.orientationNumber"
              component={Input}
              disabled={disabled}
              helpEnum={H.HOUSE_NUMBER.r}
            />

            <CroField
              className="half"
              title="PSČ"
              name="person.deliveryAddress.zip"
              component={Input}
              disabled={disabled}
            />
          </div>
        </div>

        <div className="initiativeForm__section initiativeForm__fullWidth">
          <CroSubhead title="Veřejný funkcionář" />

          <div className="initiativeForm__grid initiativeForm__grid--official">
            <CroField
              className="third"
              title="Jméno"
              name="official.firstName"
              component={Input}
              disabled
              validate={[V.required]}
            />
            <CroField
              className="third"
              title="Příjmení"
              name="official.lastName"
              component={Input}
              disabled
              validate={[V.required]}
            />
            {!disabled && (
              <div className="initiativeForm__actionsInline">
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Změnit"
                  disabled={submitting || disabled}
                  onClick={onOfficialChange}
                />
              </div>
            )}
          </div>
        </div>

        <div className="initiativeForm__section">
          <CroSubhead
            title="Obsah"
            helpEnum={H.INITIATIVE_TEXT.r}
            tooltipPosition="top-right"
          />

          <CroField
            className="textarea"
            title="Text"
            name="text"
            component={Input}
            fullWidth
            multiline
            rows={5}
            disabled={disabled}
            validate={[V.required]}
          />
          <CroTextAreaPrint label="Text" text={text} />
        </div>

        <div className="initiativeForm__section initiativeForm__fullWidth">
          <CroLabeledCmp title="Přílohy">
            <FilesGrid
              gridName={FILES_GRID_NAME}
              items={attachments}
              adding={!disabled}
              deleting={!disabled}
              uploadMode="dropzone"
              onFileAdded={onFileAdded("attachments")}
              onRemove={onRemoveFile("attachments")}
              dispatch={dispatch}
            />
          </CroLabeledCmp>
        </div>

        {isLogged(auth) && (
          <div className="initiativeForm__section">
            <div className={`initiativeForm__grid initiativeForm__grid--${state ? state.toLowerCase() : ""}`}>
              <CroField
                title="Stav"
                name="state"
                component={Select}
                items={InitiativeState}
                fullWidth
                disabled
              />
              {state === "REJECT" && (
                <>
                  <CroField
                    className="textarea initiativeForm__rejectText"
                    title="Důvod zamítnutí"
                    name="rejectText"
                    component={Input}
                    fullWidth
                    multiline
                    disabled
                    labelStyle={{ minWidth: 125 }}
                  />

                  <CroTextAreaPrint label="Důvod zamítnutí" text={rejectText} />
                </>
              )}
              {state === "FORWARDED" && (
                <>
                  <CroField
                    title="Postoupeno na"
                    name="organization"
                    component={Input}
                    fullWidth
                    disabled
                  />

                  <CroField
                    title="Postoupeno dne"
                    name="forwardedDate"
                    component={DateField}
                    fullWidth
                    disabled
                  />

                  <CroField
                    title="Důvod postoupení"
                    name="forwardingReasons"
                    component={MultiSelect}
                    url="/api/ciselniky/k-podstoupeni"
                    dispatch={dispatch}
                    label="Důvod postoupení"
                    disabled={disabled}
                  />

                  <CroField
                    title="Komentář k postoupení"
                    name="forwardingComment"
                    component={Input}
                    fullWidth
                    multiLine
                    disabled={disabled}
                    maxlen={3000}
                  />
                </>
              )}
            </div>
          </div>
        )}

        {isLogged(auth) && state === InitiativeStateRaw.FORWARDED && (
          <div className="initiativeForm__section initiativeForm__fullWidth">
            <div className="initiativeForm__grid initiativeForm__grid--result">
              <CroField
                title="Výsledek"
                name="result"
                component={Select}
                items={InitiativeResult}
                fullWidth
                disabled={disabled}
              />
            </div>

            <CroLabeledCmp title="Přílohy k výsledku">
              <FilesGrid
                gridName={RESULT_FILES_GRID_NAME}
                items={resultAttachments}
                adding={!disabled}
                deleting={!disabled}
                onFileAdded={onFileAdded("resultAttachments")}
                onRemove={onRemoveFile("resultAttachments")}
              />
            </CroLabeledCmp>
          </div>
        )}
        {state === "FORWARDED" && isLogged(auth) && (
          <CroField
            title="Poznámka"
            name="note"
            component={Input}
            fullWidth
            multiline
            disabled={disabled}
            maxlen={1000}
          />
        )}

        {!disabled && (
          <div className="initiativeForm__footer no-print">
            <div className="initiativeForm__footerInner">
              {error && <div className="error">{error}</div>}
              {!this.props.valid && this.props.submitFailed && !error && (
                <div className="error">
                  Povinná pole nejsou správně vyplněna.
                </div>
              )}
              <div className="initiativeForm__hint">
                Povinná pole jsou označena hvězdičkou.
              </div>

              <div className="initiativeForm__actions">
                <Button
                  type="button"
                  style={styles.buttons}
                  label={isInternal(auth) ? "Uložit" : "Odeslat"}
                  disabled={submitting || disabled}
                  onClick={handleSubmit(onSubmit)}
                />
                {isLogged(auth) && state === InitiativeStateRaw.NEW && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Začít vyřizovat"
                    disabled={submitting || disabled}
                    onClick={handleSubmit(accept)}
                  />
                )}
                {isLogged(auth) && state === InitiativeStateRaw.ACCEPT && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Zamítnout"
                    disabled={submitting || disabled}
                    onClick={handleSubmit(reject)}
                  />
                )}
                {isLogged(auth) && state === InitiativeStateRaw.ACCEPT && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Postoupit"
                    disabled={submitting || disabled}
                    onClick={handleSubmit(send)}
                  />
                )}
                {goBack && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Zpět"
                    onClick={goBack}
                  />
                )}
                {this.props.onShowHistory && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Zobrazit historii"
                    onClick={this.props.onShowHistory}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </form>
    );
  }
}

const ConnectedForm = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
})(InitiativeForm);

export default class InitiativeFormAdding extends Component {
  static defaultProps = {
    postProcess: identity,
  };

  async componentWillMount() {
    const { url, postProcess, dispatch } = this.props;
    if (!isNil(url)) {
      dispatch(setLoading(true, "Načítání dat..."));
      const response = await fetch(url, dispatch);
      const initialValues = await response.json();

      this.props.dispatch(initialize(FORM_NAME, postProcess(initialValues)));
      this.props.dispatch(
        dataInit(FILES_GRID_NAME, {
          items: initialValues.attachments,
          sort: "created",
          order: Order.DESC,
        }),
      );
      dispatch(setLoading());
    }
  }

  componentWillUnmount() {
    this.props.dispatch(destroy(FORM_NAME));
  }

  startAdding = () => {
    const { dispatch, location } = this.props;
    dispatch(push({ pathname: location.pathname, query: { q: "funkcionar" } }));
  };

  stopAdding = () => {
    const { dispatch, location } = this.props;
    dispatch(replace({ pathname: location.pathname }));
  };

  goBack = () => {
    this.props.router.goBack();
  }

  onOfficialChanged = (official) => {
    this.props.dispatch(change(FORM_NAME, "official", official));
    this.stopAdding();
  };

  onFileAdded = (field) => (fileRef) => {
    this.props.dispatch(arrayPush(FORM_NAME, field, fileRef));
  };

  onRemoveFile = (field) => (ids) => {
    this.props.attachments
      .map((item, index) => ({ index, id: item.id }))
      .filter((obj) => ids.includes(obj.id))
      .sort((a, b) => b.index - a.index) //descending
      .forEach((obj) =>
        this.props.dispatch(arrayRemove(FORM_NAME, field, obj.index)),
      );
  };

  fillPublicRequestOfficial = async (id) => {
    const { dispatch, location } = this.props;

    dispatch(replace({ pathname: location.pathname }));
    const response = await fetch(`/verejnost/api/funkcionari/${id}`, dispatch);
    const official = await response.json();
    dispatch(change(FORM_NAME, "official", official));
  };

  render() {
    const {
      auth,
      location: { query },
    } = this.props;

    if (!isNil(query.f)) {
      this.fillPublicRequestOfficial(query.f);
    }
    if (query.q === "funkcionar") {
      return (
        <div>
          <OfficialGrid
            url={`${auth.startUrl}/api/funkcionari`}
            onRowClick={this.onOfficialChanged}
            gridName="officialsGrid_initial"
          />
          <Button
            type="button"
            style={styles.buttons}
            label="Zpět"
            onClick={this.stopAdding}
          />
        </div>
      );
    }
    return (
      <ConnectedForm
        {...this.props}
        onOfficialChange={this.startAdding}
        onFileAdded={this.onFileAdded}
        onRemoveFile={this.onRemoveFile}
        goBack={this.goBack}
      />
    );
  }
}
